/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';

const Option = ({ label, selected, onClick }) => (
    <li
        className={classNames(
            'ui-popoverList__link cmn-filter__option',
            selected && 'cmn-filter__option_selected'
        )}
        onClick={onClick}
    >
        {label}
        <Svg
            isInlined
            iconName="tick"
            size="Medium"
            className="cmn-filter__optionTick tableShowIcon"
        />
    </li>
);

Option.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default Option;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/Option.jsx